import { render, staticRenderFns } from "./ProfileGroupList.vue?vue&type=template&id=6f9a77d6&"
import script from "./ProfileGroupList.vue?vue&type=script&lang=js&"
export * from "./ProfileGroupList.vue?vue&type=script&lang=js&"
import style0 from "./ProfileGroupList.vue?vue&type=style&index=0&id=6f9a77d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports